export default [
  {
    path: "/crowdOperating",
    component: () => import("../pages/customerOperation/crowdOperating/crowdOperating.vue"),
    name: "crowdOperating",
    title: "人群运营",
    meta: {
      title: "人群运营"
    }
  }
]